import { set_dimensions } from "../../../services/global.services";

var email_styles_2 = {
  container: {
    display: "flex",
    width: set_dimensions() ? "100%" : "",
    padding: "16px 8px 8px 8px",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: set_dimensions().desktop ? "16px" : "12px",
  },
};

export default email_styles_2;